/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { DeliveryWindow } from './DeliveryWindow';
// @ts-ignore
import {
// @ts-ignore
    DeliveryWindowFromJSON,
// @ts-ignore
    DeliveryWindowFromJSONTyped,
// @ts-ignore
    DeliveryWindowToJSON,
} from './DeliveryWindow';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { SupplierAddress } from './SupplierAddress';
// @ts-ignore
import {
// @ts-ignore
    SupplierAddressFromJSON,
// @ts-ignore
    SupplierAddressFromJSONTyped,
// @ts-ignore
    SupplierAddressToJSON,
} from './SupplierAddress';

/**
 * 
 * @export
 * @interface SupplierCreateRequest
 */
export interface SupplierCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    customerCode?: string;
    /**
     * Use the format "1d" for 1 day, "30d" for 30 days, etc.
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    creditTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    currencyCode?: string;
    /**
     * 
     * @type {Status}
     * @memberof SupplierCreateRequest
     */
    status?: Status;
    /**
     * 
     * @type {Array<SupplierAddress>}
     * @memberof SupplierCreateRequest
     */
    addresses?: Array<SupplierAddress>;
    /**
     * 
     * @type {Array<DeliveryWindow>}
     * @memberof SupplierCreateRequest
     */
    deliveryWindows?: Array<DeliveryWindow>;
    /**
     * 
     * @type {string}
     * @memberof SupplierCreateRequest
     */
    organizationId: string;
}

/**
 * Check if a given object implements the SupplierCreateRequest interface.
 */
// @ts-ignore
export function instanceOfSupplierCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "organizationId" in value;

    return isInstance;
}

// @ts-ignore
export function SupplierCreateRequestFromJSON(json: any): SupplierCreateRequest {
    return SupplierCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function SupplierCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': json['name'],
        'email': json['email'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'customerCode': !exists(json, 'customer_code') ? undefined : json['customer_code'],
        'creditTerm': !exists(json, 'credit_term') ? undefined : json['credit_term'],
        'currencyCode': !exists(json, 'currency_code') ? undefined : json['currency_code'],
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
        'addresses': !exists(json, 'addresses') ? undefined : ((json['addresses'] as Array<any>).map(SupplierAddressFromJSON)),
        'deliveryWindows': !exists(json, 'delivery_windows') ? undefined : ((json['delivery_windows'] as Array<any>).map(DeliveryWindowFromJSON)),
        'organizationId': json['organization_id'],
    };
}

// @ts-ignore
export function SupplierCreateRequestToJSON(value?: SupplierCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'email': value.email,
        'external_code': value.externalCode,
        'customer_code': value.customerCode,
        'credit_term': value.creditTerm,
        'currency_code': value.currencyCode,
        'status': StatusToJSON(value.status),
        'addresses': value.addresses === undefined ? undefined : ((value.addresses as Array<any>).map(SupplierAddressToJSON)),
        'delivery_windows': value.deliveryWindows === undefined ? undefined : ((value.deliveryWindows as Array<any>).map(DeliveryWindowToJSON)),
        'organization_id': value.organizationId,
    };
}

